'use strict';
import modalControllerP from '../../../../../components/probolivia/empresario/registro/importar.prod.modal.controller';
import modalTemplateP from '../../../../../components/probolivia/empresario/registro/importar.prod.modal.html';
class FormularioProductoController {
  constructor($log, $scope, DataService, Message, Util, Loading, Modal) {
    'ngInject';
    this.$log = $log;
    this.$scope = $scope;
    this.DataService = DataService;
    this.Message = Message;
    this.Util = Util;
    this.Loading = Loading;
    this.Modal = Modal;
    this.listaProductos = [];
    this.dataProducto = {};
    this.conf = {};
    this.insertaNuevo = false;
  }
  $onInit() {
    this.conf = this.data;
    this.productosLoad();
    this.DataService.get(`certificaciones/${this.idCertificacion}`).then(response=>{
      this.form = angular.copy(response.certificacion.formulario);
      this.esRefrigerio = false;
      this.$log.log('esRefrigerio en llenado de formulario de PRODUCTOS');
      if(this.form.id_formulario===10){
        this.esRefrigerio = true;
      } 
      this.$log.log(this.esRefrigerio);
    })
    
  }
  productosLoad() {
    this.DataService.get(`certificaciones/${this.idCertificacion}/productos`)
    .then(response => {
      if (angular.isArray(response) && response.length > 0) {
        this.listaProductos = response;
        this.$log.log("===============listado===================");
        this.$log.log(this.listaProductos);
        this.$log.log(response);
      }
    })
  }
  productoAdd() {
    this.insertaNuevo = true;
  }
  
  save(producto_form) {
    if (producto_form.$valid) {
      this.$log.log('this.idCertificacion >>||<<');
      this.$log.log(this.idCertificacion);
      this.$log.log(producto_form);
      var producto;
      producto = this.dataProducto;
      producto.principal = false;
      producto.descripcion_actividad = 'sin descripcion';
      producto.anio_inicio = 2000;
      producto.cantidad_promedio = 0;
      this.DataService.save(`certificaciones/${this.idCertificacion}/productos/`, producto)
      .then(response => {
        if (response) {
          this.$log.log(response);
          this.Message.success();
          this.dataProducto = {};
          this.productosLoad();
          this.Util.setTouchedForm(producto_form, false);
          this.insertaNuevo = false;
        }
      })
      .catch(error => {
        this.$log.log(error);
        this.Message.error('Ocurrió un error intentando guardar el producto.');
      });
    } else {
      this.Util.setTouchedForm(producto_form);
    }
  }
  productoBaja(index, item) {
    this.Modal.confirm('¿Esta seguro de que desea inactivar su producto?', () => {
      this.DataService.put(`certificaciones/${this.idCertificacion}/productos/${item.id_producto}`, item)
      .then(response => {
        if (response) {
          this.insertaNuevo = false;
          this.productosLoad();
          this.Message.success();
        }
      })
      .catch(error => {
        this.$log.log(error);
        this.Message.error('Ocurrió un error intentando guardar el producto.');
      });
    });
  }
  productoDel(index, item) {
    this.DataService.delete(`certificaciones/${this.idCertificacion}/productos/${item.id_producto}`)
    .then(response => {
      this.$log.log('==================delete=====================')
      this.$log.log(response);
      this.insertaNuevo = false;
      this.listaProductos.splice(index, 1);
      this.Message.success();
    })
    .catch(error => {
      this.$log.log(error);
      this.Message.error('Ocurrió un error intentando guardar el producto.');
    });
  }

  cancel() {
    this.insertaNuevo = false;
    // this.$uibModalInstance.close();
    // this.$uibModalInstance.dismiss('cancel');
  }

  productosImportar() {
    this.Modal.show({
      template: modalTemplateP,
      controller: modalControllerP,
      data: this,
      size: 'lg'
    });
  }
}

export default FormularioProductoController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/formularioProducto/formularioProducto.controller.js